module.exports = __webpack_public_path__ + "static/avatar_uriy_postrigay-08607cafc53b15a638d492fe2326c104.jpg";